class ShappMclSelectPaymentManager extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('.shapp-mcl-select-payment-manager__form');
    this.input = this.querySelector('.shapp-mcl-select-payment-manager__input');
    this.bankdepositOn = this.querySelector('.shapp-mcl-select-payment-manager__on');
    this.bankdepositOff = this.querySelector('.shapp-mcl-select-payment-manager__off');
    
    // Flag para evitar doble inicialización
    this.isInitialized = false;
    this.isProcessing = false;

    this.#bindEvents();
    this.#initializeState();
  }

  #bindEvents() {
    this.bankdepositOn.addEventListener('change', this.#handleRadioChange.bind(this));
    this.bankdepositOff.addEventListener('change', this.#handleRadioChange.bind(this));
  }

  async #initializeState() {
    if (this.isInitialized || this.isProcessing) return;
    
    try {
      const existingDiscounts = await this.#getExistingDiscounts();
      const discountCode = this.input.value.trim();
      
      // Temporarily disable events to avoid loops
      this.bankdepositOn.removeEventListener('change', this.#handleRadioChange.bind(this));
      this.bankdepositOff.removeEventListener('change', this.#handleRadioChange.bind(this));
      
      if (existingDiscounts.includes(discountCode)) {
        this.bankdepositOn.checked = true;
        this.bankdepositOff.checked = false;
      } else {
        this.bankdepositOn.checked = false;
        this.bankdepositOff.checked = true;
      }
      
      // Reactivate events
      this.bankdepositOn.addEventListener('change', this.#handleRadioChange.bind(this));
      this.bankdepositOff.addEventListener('change', this.#handleRadioChange.bind(this));
      
      this.isInitialized = true;
    } catch (error) {
      console.error('Error initializing state:', error);
    }
  }

  async #handleRadioChange(event) {
    const discountCode = this.input.value.trim();
    if (!discountCode || this.isProcessing) return;

    this.isProcessing = true;

    try {
      let existingDiscounts = await this.#getExistingDiscounts();
      let needsUpdate = false;
      
      if (this.bankdepositOn.checked) {
        // Add coupon if it does not exist
        if (!existingDiscounts.includes(discountCode)) {
          console.log("AGREGANDO CUPÓN TRANSFERENCIA:", discountCode);
          existingDiscounts.push(discountCode);
          needsUpdate = true;
        }
      } else if (this.bankdepositOff.checked) {
        // Remove coupon if it exists
        if (existingDiscounts.includes(discountCode)) {
          console.log("REMOVIENDO CUPÓN TRANSFERENCIA:", discountCode);
          existingDiscounts = existingDiscounts.filter(code => code !== discountCode);
          needsUpdate = true;
        }
      }

      // Only make the request if there are changes
      if (needsUpdate) {
        const response = await this.#applyCodes(existingDiscounts);
        const responseText = await response.text();

        if (response.ok) {
          const parsedState = JSON.parse(responseText);

          // Check for errors in the response
          if (parsedState.errors || parsedState.error) {
            console.error('Error applying discount:', parsedState.errors || parsedState.error);
            return;
          } else {
            await this.#handleSuccess();
          }
        }
      }
    } catch (error) {
      console.error('Error applying discount:', error);
    } finally {
      this.isProcessing = false;
    }
  }

  async #getExistingDiscounts() {
    const cartResponse = await fetch(window.routes.cart_url + '.js');
    const currentCart = await cartResponse.json();

    // Get existing discount codes - use discount_codes array
    let existingDiscounts = [];

    if (currentCart.discount_codes && Array.isArray(currentCart.discount_codes)) {
      existingDiscounts = currentCart.discount_codes
        .filter(discount => discount.applicable)
        .map(discount => discount.code);
    }

    return existingDiscounts;
  }

  async #applyCodes(existingDiscounts) {
    const discountString = existingDiscounts.join(',');

    const body = JSON.stringify({
      discount: discountString
    });

    return fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    });
  }

  #getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
    ];
  }

  async #handleSuccess() {
    // Manually refresh the cart drawer
    await this.#refreshCartDrawer();
  }

  async #refreshCartDrawer() {
    try {
      const response = await fetch(`${window.routes.cart_url}?section_id=cart-drawer`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Update cart drawer content
      const cartDrawer = document.querySelector('cart-drawer .drawer__inner');
      const newContent = html.querySelector('.drawer__inner');

      if (cartDrawer && newContent) {
        cartDrawer.innerHTML = newContent.innerHTML;
      }

      // Update cart icon
      const cartIconResponse = await fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`);
      const cartIconText = await cartIconResponse.text();
      const cartIconHtml = new DOMParser().parseFromString(cartIconText, 'text/html');
      const cartIcon = document.querySelector('#cart-icon-bubble');
      const newCartIcon = cartIconHtml.querySelector('#cart-icon-bubble');

      if (cartIcon && newCartIcon) {
        cartIcon.innerHTML = newCartIcon.innerHTML;
      }

      // Publish cart update event
      if (typeof publish !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shapp-mcl-discount-code-manager' });
      }
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
    }
  }
}

customElements.define('shapp-mcl-select-payment-manager', ShappMclSelectPaymentManager);
